import * as coreApi from "api/Core";
import GenericList from 'components/GenericList';
import * as React from 'react';
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    userId: string;
    topicId: string;
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const UserEndorsementListDrawer: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { userId, topicId, onClose } = props;

    return <GenericList
        title={t("Views.User.Dialogs.UserEndorsementListDrawer.BoxTitle")}
        showThumbnail={true}
        variant="drawer"
        onGetData={(searchText: string, offset: number, take: number) => coreApi.getUserEndorseList(userId, topicId, searchText, offset, take)}
        onClose={onClose}
    />

}

export default UserEndorsementListDrawer